<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnShortTermDebtSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Schulden aan leveranciers en handelskredieten')"
                         :calculated-value="data.calculated.balance_passive_short_term_debt_providers"
                         v-model="data.edit.balance_passive_short_term_debt_providers"/>

      <TaxReturnTableRow :description="$gettext('Schuld loonheffingen')"
                         :calculated-value="data.calculated.balance_passive_short_term_debt_salary"
                         v-model="data.edit.balance_passive_short_term_debt_salary"/>

       <TaxReturnTableRow :description="$gettext('Schuld omzetbelasting')"
                         :calculated-value="data.calculated.balance_passive_short_term_debt_profit_tax"
                         v-model="data.edit.balance_passive_short_term_debt_profit_tax"/>

       <TaxReturnTableRow :description="$gettext('Overige kortlopende schulden')"
                         :calculated-value="data.calculated.balance_passive_short_term_debt_other"
                         v-model="data.edit.balance_passive_short_term_debt_other"/>

       <TaxReturnTableRow :description="$gettext('Schuld omzetbelasting over dit boekjaar')"
                         :calculated-value="data.calculated.balance_passive_short_term_debt_this_year"
                         v-model="data.edit.balance_passive_short_term_debt_this_year"/>

       <TaxReturnTableRow :description="$gettext('Schuld omzetbelasting over het vorige boekjaar')"
                         :calculated-value="data.calculated.balance_passive_short_term_debt_previous_year"
                         v-model="data.edit.balance_passive_short_term_debt_previous_year"/>

       <TaxReturnTableRow :description="$gettext('Schuld omzetbelasting over oudere boekjaren')"
                         :calculated-value="data.calculated.balance_passive_short_term_debt_older_years"
                         v-model="data.edit.balance_passive_short_term_debt_older_years"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">
table {
  width: 100%;
}
</style>